import React, { useState } from 'react';
import {
    TableRow,
    TableCell,
    Typography
} from '@mui/material';
import { useDispatch } from 'react-redux';
import ActionButtons from '../../dashboard/actionButtons';
import { to12HourTime } from '../../../../utils/common';
import { deleteCutoffLunchMenuWatcher } from '../../../../redux/actionCreators/admin/cutoffLunchMenu';

const CutoffLunchMenuTableRow = ({ rowData, onEdit }) => {
    const dispatch = useDispatch();

    const [status, setStatus] = useState('list');
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

    const handleEdit = () => {
        onEdit(rowData)
    }

    const handleDelete = async () => {
        await dispatch(deleteCutoffLunchMenuWatcher(rowData.nID))
        setDeleteDialogOpen(false);
    }

    return (
        <TableRow hover tabIndex={-1}>
            <TableCell align="left">
                <Typography variant='t14_600'>
                    {rowData.nID}
                </Typography>
            </TableCell>

            <TableCell align="left">
                <Typography variant='t14_600'>{rowData.CutoffDate}</Typography>
            </TableCell>

            <TableCell align="left">
                <Typography variant='t14_600'>{to12HourTime(rowData.StartTime)}</Typography>
            </TableCell>

            <TableCell align="left">
                <Typography variant='t14_600'>{to12HourTime(rowData.EndTime)}</Typography>
            </TableCell>

            <TableCell align="left">
                <Typography variant='t14_600'>{rowData.LunchCount}</Typography>
            </TableCell>

            <TableCell align="left">
                <Typography variant='t14_600'>{rowData.UserTypeName}</Typography>
            </TableCell>

            <TableCell align="left">
                <Typography variant='t14_600'>{rowData.VendorName}</Typography>
            </TableCell>

            <TableCell align="left">
                <Typography variant='t14_600'>{rowData.MenuItemName}</Typography>
            </TableCell>

            <TableCell align="right">
                <ActionButtons
                    status={status}
                    setStatus={setStatus}
                    type={'cutoffLunchMenu'}
                    handleDelete={handleDelete}
                    handleEdit={handleEdit}
                    setDeleteDialogOpen={setDeleteDialogOpen}
                    deleteDialogOpen={deleteDialogOpen}
                />
            </TableCell>
        </TableRow>
    )
}

export default CutoffLunchMenuTableRow
